import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Textarea,
  Typography
} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import "../../style/datePicker.css"
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {updateWalletWithdrawal, uploadWithdrawalReceipt} from "../../services/wallet/wallet";
import FileInput from "../system/fileInput";
import FileCell from "../system/fileViewer";
import dict from "../../helper/dict";
import SelectInput from "../system/select";
import {toast} from "react-toastify";

export function AdminWithdrawalForm({withdrawal, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null)
  const [bankName, setBankName] = useState("")
  const [bankCard, setBankCard] = useState("")
  const [bankSheba, setBankSheba] = useState("")
  const [value, setValue] = useState("")
  const [description, setDescription] = useState("");
  const [receiptFile, setReceiptFile] = useState(null);
  const [initialReceipt, setInitialReceipt] = useState(null);
  const [initialStatus, setInitialStatus] = useState("")
  const [paymentType, setPaymentType] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [factorNumber, setFactorNumber] = useState("");
  const [referenceCode, setReferenceCode] = useState("");

  useEffect(() => {
    setId(withdrawal?.id ?? null);
    setBankName(withdrawal?.bank_name ?? "")
    setBankCard(withdrawal?.bank_card ?? "")
    setBankSheba(withdrawal?.bank_sheba ?? "")
    setValue(withdrawal?.value ?? "");
    setDescription(withdrawal?.description ?? "");
    setReceiptFile(null);
    setInitialReceipt(withdrawal?.receipt ?? null);
    setInitialStatus(withdrawal?.status ?? "")
    setPaymentType(withdrawal?.payment_type ?? "")
    setInvoiceNumber(withdrawal?.invoice_number ?? "")
    setFactorNumber(withdrawal?.factor_number ?? "")
    setReferenceCode(withdrawal?.reference_code ?? "")
  }, [withdrawal]);

  const closeAfterSave = () => {
    setGridSelectedRow(false)
    setLastDataRefresh(Date.now())
    handleOpen()
  };

  const saveStatus = async (sendStatus) => {

    if (initialStatus !== "new") {
      toast.error("امکان تغییر وضعیت برداشت وجود ندارد")
      return
    }

    const data = {
      id: id,
      description: description,
      status: sendStatus,
      payment_type: paymentType,
      invoice_number: invoiceNumber,
      factor_number: factorNumber,
      reference_code: referenceCode,
    };

    const result = await updateWalletWithdrawal(data);

    if (result?.status === 200) {
      if (sendStatus === "accepted" && receiptFile) {
        const receiptResult = await uploadWithdrawalReceipt(id, receiptFile);
        if (receiptResult?.status === 200) {
          closeAfterSave()
        } else {
          setInitialStatus("accepted")
        }
        return
      }

      closeAfterSave()
    }
  };

  const saveReceipt = async () => {
    if (!receiptFile) {
      toast.error("لطفا رسید واریز را انتخاب کنید")
      return
    }

    if (initialStatus !== "accepted") {
      toast.error("ابتدا باید برداشت تایید شود")
      return
    }

    const result = await uploadWithdrawalReceipt(id, receiptFile);

    if (result?.status === 200) {
      closeAfterSave()
    }
  };

  return (
    <>
      <Dialog open={open} size="md" handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll md:overflow-y-visible">

          <div className=" border-b">
            {value > 0 &&
              <Typography color="blue-gray" className="flex w-full my-2">
                {`نام بانک:  ${bankName}`}
              </Typography>
            }
          </div>

          <div className=" border-b">
            {value > 0 &&
              <Typography color="blue-gray" className="flex w-full my-2">
                {`شماره کارت:  ${persianNumberFormat(bankCard)}`}
              </Typography>
            }
          </div>

          <div className=" border-b">
            {value > 0 &&
              <Typography color="blue-gray" className="flex w-full my-2">
                {`شماره شبا:  ${persianNumberFormat(bankSheba)}`}
              </Typography>
            }
          </div>

          <div className=" border-b">
            {value > 0 &&
              <Typography color="blue-gray" className="flex w-full my-2">
                {"مبلغ برداشت از کیف پول: " + persianNumberFormat(value, true) + " ریال "}
              </Typography>
            }
          </div>

          <div>
            <SelectInput
              label="روش پرداخت"
              defaultValue={paymentType}
              options={[
                {
                  "id": "card",
                  "title": "کارت به کارت"
                },
                {
                  "id": "direct",
                  "title": "حساب به حساب"
                },
                {
                  "id": "sheba",
                  "title": "شبا"
                },
              ]}
              onChange={setPaymentType}
            />
          </div>

          <div>
            <Input
              label="شماره پیش‌فاکتور"
              placeholder="شماره پیش‌فاکتور"
              variant="standard"
              value={invoiceNumber}
              onChange={(e) => {
                setInvoiceNumber(e.target.value)
              }}
            />
          </div>

          <div>
            <Input
              label="شماره فاکتور"
              placeholder="شماره فاکتور"
              variant="standard"
              value={factorNumber}
              onChange={(e) => {
                setFactorNumber(e.target.value)
              }}
            />
          </div>

          <div>
            <Input
              label="شماره سند/ کدپیگیری"
              placeholder="شماره سند/ کدپیگیری"
              variant="standard"
              value={referenceCode}
              onChange={(e) => {
                setReferenceCode(e.target.value)
              }}
            />
          </div>

          <div>
            {!initialReceipt &&
              <FileInput label="رسید واریز" onChange={(e) => {
                setReceiptFile(e.target.files[0]);
              }}/>
            }
            {initialReceipt &&
              <FileCell fileCode={initialReceipt}/>}
          </div>

          <div>
            <Textarea
              className="w-full"
              label={`${dict('description')}`}
              variant="standard"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
          {(initialStatus === "new") &&
            <Button variant="gradient" color="gray" onClick={() => (saveStatus("accepted"))} className="ml-1">
              <span>{receiptFile ? "تایید و ثبت رسید" : "تایید برداشت"}</span>
            </Button>
          }
          {(initialStatus === "new") &&
            <Button variant="gradient" color="gray" onClick={() => (saveStatus("rejected"))} className="ml-1">
              <span>رد درخواست</span>
            </Button>
          }
          {(initialStatus === "accepted" && !initialReceipt) &&
            <Button variant="gradient" color="gray" onClick={saveReceipt} className="ml-1">
              <span>ثبت رسید</span>
            </Button>
          }
        </DialogFooter>
      </Dialog>
    </>
  );
}
